// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  * {
    /* stylelint-disable-next-line declaration-no-important */
    text-shadow: none !important;
  }
  .V2ZH2UbjSvukgQ {
    display: none;
  }
}
.pfraG4n7fUoAVg {
  overflow: hidden;
  transition: height 0.3s ease;
}
@media (prefers-reduced-motion: reduce) {
  .pfraG4n7fUoAVg {
    transition: none;
  }
}
.q7K5u2DUHwej2o {
  display: none;
  position: fixed;
  z-index: 90;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  box-sizing: border-box;
  height: 0;
  transition: background-color 0.6s ease, height 0s linear 0.6s;
  background-color: var(--ds-UNSAFE-transparent, rgba(9, 30, 66, 0));
}
.q7K5u2DUHwej2o * {
  box-sizing: border-box;
  font-family: 'Charlie Text', var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
}
.q7K5u2DUHwej2o[data-open='true'] {
  height: 100vh;
  transition: background-color 0.6s ease, height 0s linear;
  background-color: var(--ds-background-neutral, rgba(9, 30, 66, 0.5));
  cursor: pointer;
}
@media (prefers-reduced-motion: reduce) {
  .q7K5u2DUHwej2o[data-open='true'] {
    transition: none;
  }
}
@media (min-width: 992px) {
  .q7K5u2DUHwej2o {
    display: block;
  }
}
@media (prefers-reduced-motion: reduce) {
  .q7K5u2DUHwej2o {
    transition: none;
  }
}
.vPj9fZL77Otrmm {
  position: fixed;
  z-index: 100;
  top: var(--ds-space-0, 0);
  width: 100vw;
  transition: 0.5s background-color ease, 0.5s box-shadow ease;
  background-color: var(--ds-surface, #ffffff);
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px #091e4226, 0px 0px 1px #091e424f);
  cursor: default;
}
.vPj9fZL77Otrmm:hover {
  box-shadow: var(--ds-shadow-raised, 0 8px 14px rgba(9, 30, 66, 0.15));
}
@media (prefers-reduced-motion: reduce) {
  .vPj9fZL77Otrmm {
    transition: none;
  }
}
.Qe57z6KRTrmy76 {
  display: flex;
  align-items: stretch;
  height: 60px;
}
`, ""]);
// Exports
export var noPrint = `V2ZH2UbjSvukgQ`;
export var detailWrapper = `pfraG4n7fUoAVg`;
export var header = `q7K5u2DUHwej2o`;
export var innerHeader = `vPj9fZL77Otrmm`;
export var navBar = `Qe57z6KRTrmy76`;
export default ___CSS_LOADER_EXPORT___;
